"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.set = exports.get = void 0;
const lru_cache_1 = require("lru-cache");
let lruCache;
if (process.env.IMGIX_CACHE_ENABLED === 'true') {
    const max = process.env.IMGIX_CACHE_MAX ? +process.env.IMGIX_CACHE_MAX : 5000;
    lruCache = new lru_cache_1.LRUCache({
        max,
        updateAgeOnGet: true,
        updateAgeOnHas: false,
    });
}
function get(sourceUrl, cacheKey) {
    return lruCache?.get(sourceUrl)?.get(cacheKey);
}
exports.get = get;
function set(sourceUrl, cacheKey, value) {
    if (!lruCache) {
        return;
    }
    const cachedImage = lruCache.get(sourceUrl) ?? new Map();
    cachedImage.set(cacheKey, value);
    lruCache.set(sourceUrl, cachedImage);
}
exports.set = set;
//# sourceMappingURL=cache.js.map